// extracted by mini-css-extract-plugin
export default {"content":"_w0Du3xRUybkIiMPSQMY","delete-group":"mDoe6IWOTduWizyYI8DO"};